import { FC } from 'react';
import { css } from '@emotion/react';
import { colors } from '../../../styles';
import { ToolRendererProps } from './types';
import { LoadingState } from './shared/LoadingState';
import { SENTIMENT_COLORS } from './shared/constants';

// Generic/Fallback Renderer
export const GenericRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return <LoadingState message="Processing..." />;
  }

  if (output.message) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.liquorice};
          line-height: 1.4;

          html[data-theme='dark'] & {
            color: ${colors.sugar};
          }
        `}
      >
        {output.message}
      </div>
    );
  }

  if (output.status === 'success') {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${SENTIMENT_COLORS.positive};
        `}
      >
        Tool completed successfully
      </div>
    );
  }

  if (output.status === 'error') {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${SENTIMENT_COLORS.negative};
        `}
      >
        Tool execution failed
      </div>
    );
  }

  return <LoadingState message="Tool executed" />;
};
